module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/Precipitation/Nagano_Precipitation_MRI_RCP85_End.png";